import { Dispatch } from 'redux';
import { patchNotification } from '../../global/ducks/notification-prc-api';
import { Notification, NotificationStatus } from './notification-models';
import { setNotificationRead } from './notification-slice';

export const dismissNotification = (dispatch: Dispatch, notification: Notification) => {
	if (notification?.is_mandatory) return;
	dispatch(setNotificationRead(notification.notification_id));
	dispatch(patchNotification(notification.notification_id, {
		notification_status: NotificationStatus.DISMISSED,
		notification_type: notification.notification_type,
		recipient_guid: notification.recipient_guid,
	}, () => {}));
};
